var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStarOutline = function SvgStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.047 21.21-7.96 4.457 1.777-8.948-6.698-6.194 9.06-1.074 3.82-8.284 3.822 8.284 9.06 1.074-6.698 6.194 1.777 8.948-7.96-4.456Zm0-2.586 4.793 2.683-1.07-5.387 4.032-3.73-5.455-.647-2.3-4.987-2.3 4.988-5.455.646 4.033 3.73-1.071 5.387 4.793-2.683Z",
    fill: "#25241D"
  })));
};

export { SvgStarOutline as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjA0NjkgMjEuMjEwOEw2LjA4Njc4IDI1LjY2NjZMNy44NjQzNSAxNi43MTlMMS4xNjYwMiAxMC41MjUxTDEwLjIyNTQgOS40NTA2N0wxNC4wNDY5IDEuMTY2NjNMMTcuODY4NCA5LjQ1MDY3TDI2LjkyNzggMTAuNTI1MUwyMC4yMjk1IDE2LjcxOUwyMi4wMDcgMjUuNjY2NkwxNC4wNDY5IDIxLjIxMDhaTTE0LjA0NjkgMTguNjI0MUwxOC44NDAxIDIxLjMwNjhMMTcuNzY5MSAxNS45MTk5TDIxLjgwMTYgMTIuMTg5OEwxNi4zNDcgMTEuNTQzMUwxNC4wNDY5IDYuNTU1NzdMMTEuNzQ2OCAxMS41NDQzTDYuMjkyMTkgMTIuMTg5OEwxMC4zMjQ3IDE1LjkxOTlMOS4yNTM2OCAyMS4zMDY4TDE0LjA0NjkgMTguNjI0MVoiIGZpbGw9IiMyNTI0MUQiLz4KPC9zdmc+Cg==";